module.exports = __webpack_public_path__ + "a61e4e609c7b55c6b39c3d89517688e3.svg";